import { BotDialog, BotDialogContentConfirmWords } from 'components/BotDialog';

export default function BotDialogOverridableWords({
  overridableWords,
  onCancel,
  onConfirm,
  show = false,
  busy = false,
}) {
  return (
    <BotDialog
      show={show}
      busy={busy}
      title="Warning: Overridable Words"
      description={`You’ve entered a possible risk word(s) into your last message. Please re-enter that word below to confirm you meant to send it.`}
    >
      <BotDialogContentConfirmWords words={overridableWords} onCancel={onCancel} onConfirm={onConfirm} />
    </BotDialog>
  );
}
